export default "__VITE_ASSET__sQmXi5Ni__"